import "./InfoItem.css";

export default function InfoItem({
  label,
  value,
  className = "",
  align = "start",
  reverse = false,
  size = "",
}) {
  return (
    <div
      className={`ui-info-item ${reverse ? "reverse" : ""} ${size} ${className}`}
      data-align={align}
    >
      <span className="ui-info-item-label">
        {label}
      </span>

      <strong className="ui-info-item-value">
        {value}
      </strong>
    </div>
  );
}
